import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION = 'navigatorMusic';
const VIDEO_ID = /^[\w-]{11}$/;

export function navigatorMusicArtworkUrl(nowPlaying) {
  if (!nowPlaying || typeof nowPlaying !== 'object') return null;
  const thumb =
    typeof nowPlaying.thumbnailUrl === 'string'
      ? nowPlaying.thumbnailUrl.trim()
      : '';
  if (thumb) return upgradeYoutubeThumb(thumb);
  const id = typeof nowPlaying.id === 'string' ? nowPlaying.id.trim() : '';
  if (nowPlaying.kind !== 'playlist' && VIDEO_ID.test(id)) {
    return `https://i.ytimg.com/vi/${encodeURIComponent(id)}/hqdefault.jpg`;
  }
  return null;
}

function upgradeYoutubeThumb(url) {
  return url.replace(
    /\/vi\/([^/?#]+)\/(default|mqdefault)\.jpg(\?.*)?$/i,
    '/vi/$1/hqdefault.jpg'
  );
}

export function subscribeNavigatorMusicArtwork(uid, onUrl) {
  return onSnapshot(
    doc(db, COLLECTION, uid),
    (snap) => {
      onUrl(navigatorMusicArtworkUrl(snap.data()?.nowPlaying));
    },
    () => {
      onUrl(null);
    }
  );
}
